import type { ProcedureDetail } from "./procedures.js";
import { procedures } from "./procedures.js";

export interface HomepageStep {
	number: string;
	headline: string;
	perex: string;
	text: string;
	imageKey: string;
	imageAlt: string;
	buttonText?: string;
	buttonHref?: string;
}

export interface HomepageInfoCard {
	headline: string;
	text: string;
	imageKey: string;
	imageAlt: string;
	buttonText?: string;
	buttonHref?: string;
}

export interface ProcessCarouselImage {
	imageKey: string;
	imageAlt: string;
}

export type RatingValue = 0 | 0.5 | 1 | 1.5 | 2 | 2.5 | 3 | 3.5 | 4 | 4.5 | 5;

export interface Review {
	name: string;
	rating?: RatingValue;
	text: string;
	photo?: string;
}

export interface BioPerson {
	name: string;
	text: string;
	photoKey: string;
	photoAlt: string;
}

export interface ProcedureProcessStep {
	stepNumber: string;
	headline: string;
	text: string;
}

export type FaqPage = "homepage" | "vouchers" | "faq";

export interface FaqQuestion {
	question: string;
	answer: string;
	buttonText?: string;
	buttonHref?: string;
	pages: FaqPage[];
}

export interface HomepageData {
	featuredProcedures: ProcedureDetail[];
	steps: HomepageStep[];
	infoCards: HomepageInfoCard[];
	processCarouselImages: ProcessCarouselImage[];
	processStepsHeading: string;
	procedureProcessSteps: ProcedureProcessStep[];
	reviews: Review[];
	faqs: FaqQuestion[];
	bioPersons: BioPerson[];
}

export const homepageData = {
	featuredProcedures: procedures.slice(0, 3),
	steps: [
		{
			number: "1",
			headline: "Co je to head spa?",
			perex: "",
			text: "Head Spa je relaxační wellness procedura, která kombinuje péči o vlasovou pokožku a vlasy s hlubokou relaxací. U nás je navíc součástí i jemná péče o pleť.",
			imageKey: "step-1",
			imageAlt: "Co je to head spa?",
		},
		{
			number: "2",
			headline: "Jaké problémy head spa napohodu řeší?",
			perex: "",
			text: "Pomůžeme vám s regulací tvorby lupů, zklidníme podrážděnou pokožku, optimalizujeme tvorbu kožního mazu, podpoříme růst vlasů a vyživíme nejen vlasovou pokožku ale i samotné vlasy. Při delších procedurách se zaměřujeme i na hydrataci pleti. Taky vám garantujeme, že při procedurách vypnete mozek, čímž podpoříme regeneraci těla i mysli.",
			imageKey: "step-2",
			imageAlt: "Jaké problémy head spa napohodu řeší?",
			buttonText: "VÝBĚR PROCEDURY",
			buttonHref: "/procedury",
		},
		{
			number: "3",
			headline: "Proč je head spa vhodný dárek?",
			perex: "",
			text: "Protože je to čas úplně napohodu. Chvíle, kdy se zastaví čas, vypne hlava a člověk si dopřeje něco, co si sám často nedovolí. A ruku na srdce – kdo by nemiloval masáže a jemné škrabkání?",
			imageKey: "step-3",
			imageAlt: "Proč je head spa vhodný dárek?",
			buttonText: "VYBRAT POUKAZ",
			buttonHref: "/poukazy",
		},
	],
	infoCards: [
		{
			headline: "Před procedurou",
			text: "- rezervuj si svůj termín přes rezervační systém\n- umyj si vlasy 4-2 dny před procedurou (pokud se ti vlasy hodně mastí, klidně je umyj den předem)\n- v případě dotazů se na nás obraceje do zpráv na IG, FB, e-mail nebo tel.",
			imageKey: "procedure-1",
			imageAlt: "Před procedurou",
			buttonText: "REZERVOVAT TERMÍN",
			buttonHref: "/rezervace",
		},
		{
			headline: "Pro koho je masáž vhodná?",
			text: "- do salonu přicházíš max. 5 minut předem\n- začínáme s diagnostikou vlasové pokožky a vlasů na křesle (mikrokamera + rozhovor)\n- poté se převlékáš (vrchní díl oblečení vyměníš za ručník)\n- přesouváš se na lehátko a začínáme s péčí a relaxací \n- s turbanem na hlavě máš prostor k závěrečnému odpočinku na lehátku\n- přesouváš se na křeslo a vlasy vyfoukáme\n( - máš možnost zakoupit si vlasové produkty, které ti doporučíme dle tvých individuálních potřeb )",
			imageKey: "procedure-1",
			imageAlt: "Pro koho je masáž vhodná?",
			buttonText: "REZERVOVAT TERMÍN",
			buttonHref: "/rezervace",
		},
		{
			headline: "Kvalitní ověřené produkty",
			text: "- ocházíš odpočatý s čistou hlavou domů",
			imageKey: "procedure-1",
			imageAlt: "Kvalitní ověřené produkty",
			buttonText: "REZERVOVAT TERMÍN",
			buttonHref: "/rezervace",
		},
	],
	processCarouselImages: [
		{ imageKey: "carousel-1", imageAlt: "Head Spa procedura" },
		{ imageKey: "carousel-2", imageAlt: "Head Spa procedura" },
		{ imageKey: "carousel-3", imageAlt: "Head Spa procedura" },
		{ imageKey: "carousel-4", imageAlt: "Head Spa procedura" },
		{ imageKey: "carousel-5", imageAlt: "Head Spa procedura" },
		{ imageKey: "carousel-6", imageAlt: "Head Spa procedura" },
		{ imageKey: "carousel-7", imageAlt: "Head Spa procedura" },
		{ imageKey: "carousel-8", imageAlt: "Head Spa procedura" },
		{ imageKey: "carousel-9", imageAlt: "Head Spa procedura" },
		{ imageKey: "carousel-10", imageAlt: "Head Spa procedura" },
		{ imageKey: "carousel-11", imageAlt: "Head Spa procedura" },
		{ imageKey: "carousel-12", imageAlt: "Head Spa procedura" },
		{ imageKey: "carousel-13", imageAlt: "Head Spa procedura" },
		{ imageKey: "carousel-14", imageAlt: "Head Spa procedura" },
		{ imageKey: "carousel-15", imageAlt: "Head Spa procedura" },
		{ imageKey: "carousel-16", imageAlt: "Head Spa procedura" },
		{ imageKey: "carousel-17", imageAlt: "Head Spa procedura" },
		{ imageKey: "carousel-18", imageAlt: "Head Spa procedura" },
	],
	processStepsHeading: "Jak procedura probíhá?",
	procedureProcessSteps: [
		{
			stepNumber: "KROK 1",
			headline: "Diagnostika vlasové pokožky a vlasů",
			text: "Mikrokamerou se podíváme, jak to vypadá s tvojí vlasovou pokožkou, a z rozhovoru zjistíme, co tě trápí. Neboj se říct pravdu – nic nebudeme soudit ani tě poučovat. Prostě se snažíme najít řešení, které ti skutečně pomůže. Díky tomu uzpůsobíme samotnou proceduru na míru, aby tvoje vlasy dostaly tu nejlepší péči!",
		},
		{
			stepNumber: "KROK 2",
			headline: "Procedura - Relax a péče v jednom",
			text: "Druhý krok = čistá pohoda! Spojíme relaxaci s účinnou péčí – tvoje vlasy a pokožku hlavy vyčistíme a vyživíme, zatímco si budeš užívat masáže a pohodovou atmosféru. V této fázi se soustředíme na to, aby tvoje vlasy dostaly vše potřebné a ty sis přitom dokonale odpočinul.",
		},
		{
			stepNumber: "KROK 3",
			headline: "Vyfoukání vlasů a individuální sestavení domácí péče",
			text: "Na závěr ti vlasy krásně vyfoukáme, aby byly nejen zdravé, ale i krásně upravené. Pak si popovídáme o tom, jak o ně pečovat i doma – poradíme ti, co použít a jak postupovat při péči, aby tvoje vlasy byly vždy v top kondici.",
		},
	],
	reviews: [
		{
			name: "Iza",
			rating: 5,
			text: "Strasne moc dekuji, bylo to uplne bozii, fakt jsem se premistila uplne do jine reality, prislo mi, jako bych byla nekde v Rakousku/Svycarsku v 5hvezdickovem hotelu  uz jsem te doporucila kamoskam, mamce, segre",
		},
		{
			name: "Barbara",
			rating: 5,
			text: "Návštěva salónu Head Spa napohodu byla opravdu výjimečným zážitkem. Majitelka mě celou procedurou jemně a klidně provázela, takže jsem přesně věděla, co se děje, bude dít, a mohla se úplně uvolnit. Je vidět, že svou práci dělá s obrovskou láskou a péčí, a člověk to cítí od první chvíle. Všechny pomůcky použité při masáži hlavy, rukou a ramen byly moc příjemné a přispěly k celkovému pocitu dokonalého hýčkání. Salón je krásný, voňavý a působí jako oáza klidu. Vlasy po ošetření vypadají božsky, jsou hebké a nádherně voní. Určitě se vrátím a s radostí doporučuji všem, kdo si chtějí dopřát chvíli pro sebe a odejít s pocitem skutečného hýčkání.",
		},
		{
			name: "Silvie",
			rating: 5,
			text: "Byla jsem už v létě, ale teprve jsem se dostala k napsání recenze. Skvělý zážitek, dokonalý relax. Útulné a čisté prostředí, moc milá paní majitelka. Líbilo se mi, že zážitek byl komplexnínl[[]]- zatímco vám působí maska na vlasech, dostane se vám masáže obličeje; při napářce jsem dostala masáž rukou. Vše krásně vysvětleno, spoustu věcí se dozvíte, takže pak můžete aplikovat i doma a není to jen o tom jednom konkrétním dni. Opravdu moc doporučuji a ráda přijdu zas. 💛",
		},
		{
			name: "Aneta",
			rating: 5,
			text: "Úžasný zážitek, který je definicí relaxu a péče o sebe ✨ Head spa jsem absolvovala již vícekrát v jiných zařízení, ale péče co zažijete v Head spa napohodu se nedá srovnat. Moc příjemná slečna, která má vše do detailu promyšlené. Krásné a útulné prostředí. Po celou dobu Vás provází klidným hlasem, jednotlivé kroky na sebe plynule navazují a Vy máte pocit, že každá vaše buňka dostává pozornost. Souhra detailů, která dává smysl. Vřele doporučuji všem. Moc ráda se budu vracet ♥️",
		},
		{
			name: "Bára",
			rating: 5,
			text: "Head Spa jsem vyzkoušela několikrát jinde, ale ta péče se nedá srovnat. Tohle byl wellness rituál, který mě dostal do totálního ZENU. Hladivé provádění hlasem spolu s profesionálním poradenstvím a péčí o vlasovou pokožku tomu všemu přidává na hodnotě a celá péče tak má obrovský přesah! Mockrát děkuji! Určitě jsem nebyla naposled🥹✨",
		},
		{
			name: "Tereza",
			rating: 5,
			text: "Majitelka salónu si opravdu dává záležet na tom, aby bylo všechno ťip ťop. Z procedury vytváří zážitek, do každého doteku vkládá kus sebe, a ona přidaná hodnota je opravdu znát. Moc děkuji za takovou formu relaxu a péče, určitě se zastavím znovu :-)",
		},
	],
	faqs: [
		{
			question: "Co je to vlastně Head Spa?",
			answer:
				"Head Spa je relaxačí wellness procedura, která kombinuje péči o vlasovou pokožku a vlasy s hlubokou relaxací. U nás je navíc součástí i jemná péče o pleť.",
			pages: ["homepage", "faq"],
		},
		{
			question: "Jaké problémy Head Spa řeší?",
			answer:
				"Pomůžeme ti s regulací tvorby lupů, zklidníme podrážděnou pokožku, optimalizujeme tvorbu kožního mazu, podpoříme růst vlasů a vyživíme nejen vlasovou pokožku ale i samotné vlasy. Při delších procedurách se zaměřujeme i na hydrataci pleti. Taky ti garantujeme, že při procedurách vypneš mozek, čímž podpoříme regeneraci těla i mysli.",
			pages: ["homepage", "faq"],
		},
		{
			question: "Pro koho Head Spa není vhodné?",
			answer:
				"Na Head Spa nechoď pokud: nl[[]]- jsi nemocný (nachlazení, horečka, bolest hlavy, zánět uší nebo dutin, nevolnost)nl[[]]- máš otevřené rány na hlavě, lupénku v akutním stavu, ekzém na hlavě, silnou seboreu nebo plísňové onemocněnínl[[]]- máš hodně vysoký nebo hodně nízký krevní tlaknl[[]]- trpíš epilepsiínl[[]]- procházíš si onkologickou léčbounl[[]]- trpíš onemocnením lymfatického systémunl[[]]- máš prodloužené vlasy",
			pages: ["faq"],
		},
		{
			question: "Jak se mám obléct a co si vzít s sebou?",
			answer:
				"Stačí pohodlné oblečení, ve kterém se budeš cítit příjemně. U nás si jen vyměníš vrchní díl oblečení za ručník. S sebou nemusíš nosit nic speciálního, stačí telefon nebo hotovost pro platbu.",
			pages: ["faq"],
		},
		{
			question: "Jak u vás můžu platit?",
			answer: "Hotově (prosíme přesně) nebo převodem přes QR kód.",
			pages: ["homepage", "vouchers", "faq"],
		},
		{
			question: "Mám se před procedurou odlíčit nebo můžu přijít nalíčená?",
			answer:
				"Doporučujeme přijít bez make-upu. Pokud ale poběžíš rovnou z práce nebo z důležité schůzky, rádi tě odlíčíme na místě na začátku procedury.",
			pages: ["faq"],
		},
		{
			question: "Kolik dní před procedurou si mám umýt vlasy?",
			answer: "4-2 dny před procedurou (pokud se vám vlasy hodně mastí, klidně je umyj den předem)",
			pages: ["faq"],
		},
		{
			question: "Je Head Spa vhodné pro těhotné?",
			answer:
				"Pokud máš bezproblémové těhotenství bez nevolností a je ti pohodlné ležet na zádech, tak určitě ano. Vždy se ale raději poraď se svým lékařem.",
			pages: ["homepage", "faq"],
		},
		{
			question: "S jakými značkami v salonu pracujete?",
			answer:
				"Vlasové produkty značky Davines a Navlasil. Alginátové masky od Esthemax. Esenciální olejíčky od Saloos a pleťovou kosmetiku korejských značek.",
			pages: ["faq"],
		},
		{
			question: "Je Head Spa vhodné pro muže?",
			answer:
				"Ano! Pánové si u nás užijí masáže, škrabkání, parní lázeň v kombinaci s cílenou péčí pro podporu růstu vlasů.",
			pages: ["homepage", "faq"],
		},
		{
			question: "Je po proceduře potřeba nějaká speciální péče?",
			answer:
				"Po proceduře je vhodné dodržovat domácí péči podle doporučení, které ti poskytneme. To zahrnuje používání specifických produktů a pravidelnou péči pro dosažení dlouhodobých výsledků.",
			pages: ["faq"],
		},
		{
			question: "Jak můžu pořídit dárkový poukaz?",
			answer:
				"Stačí nám napsat váš e-mail, celé jméno obdarovaného a jak ho chcete na poukazu oslovit, kterou proceduru chcete darovat, zda chcete poukaz v online verzi nebo si ho chcete vyzvednout osobně",
			buttonText: "Formulář k poukazům",
			buttonHref: "/poukazy#objednat",
			pages: ["homepage", "vouchers", "faq"],
		},
	],
	bioPersons: [
		{
			name: "Nikit",
			text: "Jsem Nikit, akční člověk, který našel svůj klid a teď ho předává dál. V mém head spa propojuji péči o vlasy a pokožku s kreativní energií, vnitřním klidem a osobním přístupem. Mým hlavním cílem je, aby každá head spa procedura byla malým rituálem, ze kterého si odneseš klid na duši.",
			photoKey: "bio-1",
			photoAlt: "Nikit - terapeut",
		},
		{
			name: "Markét",
			text: "Jsem Markét a našla jsem své místo v head spa napohodu, kde můžu pečovat o druhé a zároveň si užít svůj malý odpočinek. Spojuji péči, empatii a klid. Zároveň si zakládám na tom, abych ti předala vše, co znám o vlasech a pokožce.",
			photoKey: "bio-2",
			photoAlt: "Markét - terapeut",
		},
	],
} satisfies HomepageData;
